import { createContext, useContext } from 'react';
import { useLoadTranslations } from '../i18n/useLoadTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
const LocaleContext = /*#__PURE__*/createContext('en');
export const LocaleProvider = ({
  locale,
  children
}) => {
  useLoadTranslations(locale);
  return /*#__PURE__*/_jsx(LocaleContext.Provider, {
    value: locale,
    children: children
  });
};
export function useLocale() {
  return useContext(LocaleContext);
}